import Swiper from '../../common/custom-swiper/custom-swiper';
import LazyLoad from '../../../js/lazy-load';

export default new class brandSlider {
  constructor() {
    this.sliderContainerSelector = 'brand-slider__container';
    this.reverseSliderContainerSelector = 'brand-slider-reverse__container';
    this.slideSelector = 'brand-slider__slide';

    this.handler();
  }

  handler() {
    const slider = document.querySelector(`.${this.sliderContainerSelector}`);

    if (!slider) return;

    document.addEventListener('DOMContentLoaded', () => {
      this.init(slider);
    });
  }

  init(slider) {
    const slides = slider.querySelectorAll(`.${this.slideSelector}`);

    this.brandSlider = new Swiper(`.${this.sliderContainerSelector}`, {
      autoplay: true,
      speed: 5000,
      autoplay: {
        delay: 0
      },
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 40,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      observer: true,
      loop: slides.length > 2,
      on: {
        init: () => {
          LazyLoad.update();
        },
      },
    });

  this.brandSliderReverse = new Swiper(`.${this.reverseSliderContainerSelector}`, {
    autoplay: true,
    speed: 5000,
    autoplay: {
      delay: 0,
      reverseDirection: true
    },
    centeredSlides: true,
    slidesPerView: 'auto',
    spaceBetween: 40,
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    observer: true,
    loop: slides.length > 2,
    on: {
      init: () => {
        LazyLoad.update();
      },
    },
  });
}

}();
